export default __webpack_public_path__ + "static/media/save-money.8c847d7b.svg";